/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SearchResultRequestDTODecisionEnum = {
    Saleable: 'SALEABLE',
    Recheck: 'RECHECK',
    Unsaleable: 'UNSALEABLE'
};
/**
 * @export
 */
export const SearchResultRequestDTOMerchantTypeEnum = {
    Fba: 'FBA',
    Fbm: 'FBM',
    Sba: 'SBA'
};
/**
 * @export
 */
export const SearchResultRequestDTOTargetChineseSellerEnum = {
    Has: 'HAS',
    None: 'NONE'
};
/**
 * @export
 */
export const SearchResultRequestDTOMatchModeEnum = {
    All: 'ALL',
    Any: 'ANY'
};
/**
 * Check if a given object implements the SearchResultRequestDTO interface.
 */
export function instanceOfSearchResultRequestDTO(value) {
    return true;
}
export function SearchResultRequestDTOFromJSON(json) {
    return SearchResultRequestDTOFromJSONTyped(json, false);
}
export function SearchResultRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'decision': json['decision'] == null ? undefined : json['decision'],
        'keyword': json['keyword'] == null ? undefined : json['keyword'],
        'staged': json['staged'] == null ? undefined : json['staged'],
        'purchasePriceUsdMin': json['purchasePriceUsdMin'] == null ? undefined : json['purchasePriceUsdMin'],
        'purchasePriceUsdMax': json['purchasePriceUsdMax'] == null ? undefined : json['purchasePriceUsdMax'],
        'shippingPriceUsdMin': json['shippingPriceUsdMin'] == null ? undefined : json['shippingPriceUsdMin'],
        'shippingPriceUsdMax': json['shippingPriceUsdMax'] == null ? undefined : json['shippingPriceUsdMax'],
        'sourceCategoryBsrMin': json['sourceCategoryBsrMin'] == null ? undefined : json['sourceCategoryBsrMin'],
        'sourceCategoryBsrMax': json['sourceCategoryBsrMax'] == null ? undefined : json['sourceCategoryBsrMax'],
        'sourceSubcategoryBsrMin': json['sourceSubcategoryBsrMin'] == null ? undefined : json['sourceSubcategoryBsrMin'],
        'sourceSubcategoryBsrMax': json['sourceSubcategoryBsrMax'] == null ? undefined : json['sourceSubcategoryBsrMax'],
        'sourceReviewMin': json['sourceReviewMin'] == null ? undefined : json['sourceReviewMin'],
        'sourceReviewMax': json['sourceReviewMax'] == null ? undefined : json['sourceReviewMax'],
        'sourceReviewRatingMin': json['sourceReviewRatingMin'] == null ? undefined : json['sourceReviewRatingMin'],
        'sourceReviewRatingMax': json['sourceReviewRatingMax'] == null ? undefined : json['sourceReviewRatingMax'],
        'sourceBoughtPastMonthMin': json['sourceBoughtPastMonthMin'] == null ? undefined : json['sourceBoughtPastMonthMin'],
        'sourceBoughtPastMonthMax': json['sourceBoughtPastMonthMax'] == null ? undefined : json['sourceBoughtPastMonthMax'],
        'sourceRootCategory': json['sourceRootCategory'] == null ? undefined : json['sourceRootCategory'],
        'merchantType': json['merchantType'] == null ? undefined : json['merchantType'],
        'availability': json['availability'] == null ? undefined : json['availability'],
        'isBestSeller': json['isBestSeller'] == null ? undefined : json['isBestSeller'],
        'sourceShippingPriceUsdMin': json['sourceShippingPriceUsdMin'] == null ? undefined : json['sourceShippingPriceUsdMin'],
        'sourceShippingPriceUsdMax': json['sourceShippingPriceUsdMax'] == null ? undefined : json['sourceShippingPriceUsdMax'],
        'sourceTotalOfferCountMin': json['sourceTotalOfferCountMin'] == null ? undefined : json['sourceTotalOfferCountMin'],
        'sourceTotalOfferCountMax': json['sourceTotalOfferCountMax'] == null ? undefined : json['sourceTotalOfferCountMax'],
        'sourcePrimeOfferCountMin': json['sourcePrimeOfferCountMin'] == null ? undefined : json['sourcePrimeOfferCountMin'],
        'sourcePrimeOfferCountMax': json['sourcePrimeOfferCountMax'] == null ? undefined : json['sourcePrimeOfferCountMax'],
        'deliveryPromiseDaysMin': json['deliveryPromiseDaysMin'] == null ? undefined : json['deliveryPromiseDaysMin'],
        'deliveryPromiseDaysMax': json['deliveryPromiseDaysMax'] == null ? undefined : json['deliveryPromiseDaysMax'],
        'returnable': json['returnable'] == null ? undefined : json['returnable'],
        'freeReturns': json['freeReturns'] == null ? undefined : json['freeReturns'],
        'amazonsChoice': json['amazonsChoice'] == null ? undefined : json['amazonsChoice'],
        'primeExclusive': json['primeExclusive'] == null ? undefined : json['primeExclusive'],
        'voltageMin': json['voltageMin'] == null ? undefined : json['voltageMin'],
        'voltageMax': json['voltageMax'] == null ? undefined : json['voltageMax'],
        'bulbBase': json['bulbBase'] == null ? undefined : json['bulbBase'],
        'powerSource': json['powerSource'] == null ? undefined : json['powerSource'],
        'sourceSalesRank': json['sourceSalesRank'] == null ? undefined : json['sourceSalesRank'],
        'targetSalesRank': json['targetSalesRank'] == null ? undefined : json['targetSalesRank'],
        'targetCategoryBsrMin': json['targetCategoryBsrMin'] == null ? undefined : json['targetCategoryBsrMin'],
        'targetCategoryBsrMax': json['targetCategoryBsrMax'] == null ? undefined : json['targetCategoryBsrMax'],
        'targetSubcategoryBsrMin': json['targetSubcategoryBsrMin'] == null ? undefined : json['targetSubcategoryBsrMin'],
        'targetSubcategoryBsrMax': json['targetSubcategoryBsrMax'] == null ? undefined : json['targetSubcategoryBsrMax'],
        'totalOfferCountMin': json['totalOfferCountMin'] == null ? undefined : json['totalOfferCountMin'],
        'totalOfferCountMax': json['totalOfferCountMax'] == null ? undefined : json['totalOfferCountMax'],
        'targetHasPrimeOffer': json['targetHasPrimeOffer'] == null ? undefined : json['targetHasPrimeOffer'],
        'targetHasBuybox': json['targetHasBuybox'] == null ? undefined : json['targetHasBuybox'],
        'targetHasAmazonSeller': json['targetHasAmazonSeller'] == null ? undefined : json['targetHasAmazonSeller'],
        'targetHasFBASeller': json['targetHasFBASeller'] == null ? undefined : json['targetHasFBASeller'],
        'sourceBuyboxSellerChinese': json['sourceBuyboxSellerChinese'] == null ? undefined : json['sourceBuyboxSellerChinese'],
        'sourceBrandAndSellerSame': json['sourceBrandAndSellerSame'] == null ? undefined : json['sourceBrandAndSellerSame'],
        'targetChineseSeller': json['targetChineseSeller'] == null ? undefined : json['targetChineseSeller'],
        'targetBrandSeller': json['targetBrandSeller'] == null ? undefined : json['targetBrandSeller'],
        'sellingPriceMin': json['sellingPriceMin'] == null ? undefined : json['sellingPriceMin'],
        'sellingPriceMax': json['sellingPriceMax'] == null ? undefined : json['sellingPriceMax'],
        'totalCostUsdMin': json['totalCostUsdMin'] == null ? undefined : json['totalCostUsdMin'],
        'totalCostUsdMax': json['totalCostUsdMax'] == null ? undefined : json['totalCostUsdMax'],
        'profitUsdMin': json['profitUsdMin'] == null ? undefined : json['profitUsdMin'],
        'profitUsdMax': json['profitUsdMax'] == null ? undefined : json['profitUsdMax'],
        'minProfitUsdMin': json['minProfitUsdMin'] == null ? undefined : json['minProfitUsdMin'],
        'minProfitUsdMax': json['minProfitUsdMax'] == null ? undefined : json['minProfitUsdMax'],
        'priceDiffBuyboxMin': json['priceDiffBuyboxMin'] == null ? undefined : json['priceDiffBuyboxMin'],
        'priceDiffBuyboxMax': json['priceDiffBuyboxMax'] == null ? undefined : json['priceDiffBuyboxMax'],
        'priceDiffLowestMin': json['priceDiffLowestMin'] == null ? undefined : json['priceDiffLowestMin'],
        'priceDiffLowestMax': json['priceDiffLowestMax'] == null ? undefined : json['priceDiffLowestMax'],
        'isPriceBelowBuybox': json['isPriceBelowBuybox'] == null ? undefined : json['isPriceBelowBuybox'],
        'matchMode': json['matchMode'] == null ? undefined : json['matchMode'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}
export function SearchResultRequestDTOToJSON(json) {
    return SearchResultRequestDTOToJSONTyped(json, false);
}
export function SearchResultRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'searchId': value['searchId'],
        'decision': value['decision'],
        'keyword': value['keyword'],
        'staged': value['staged'],
        'purchasePriceUsdMin': value['purchasePriceUsdMin'],
        'purchasePriceUsdMax': value['purchasePriceUsdMax'],
        'shippingPriceUsdMin': value['shippingPriceUsdMin'],
        'shippingPriceUsdMax': value['shippingPriceUsdMax'],
        'sourceCategoryBsrMin': value['sourceCategoryBsrMin'],
        'sourceCategoryBsrMax': value['sourceCategoryBsrMax'],
        'sourceSubcategoryBsrMin': value['sourceSubcategoryBsrMin'],
        'sourceSubcategoryBsrMax': value['sourceSubcategoryBsrMax'],
        'sourceReviewMin': value['sourceReviewMin'],
        'sourceReviewMax': value['sourceReviewMax'],
        'sourceReviewRatingMin': value['sourceReviewRatingMin'],
        'sourceReviewRatingMax': value['sourceReviewRatingMax'],
        'sourceBoughtPastMonthMin': value['sourceBoughtPastMonthMin'],
        'sourceBoughtPastMonthMax': value['sourceBoughtPastMonthMax'],
        'sourceRootCategory': value['sourceRootCategory'],
        'merchantType': value['merchantType'],
        'availability': value['availability'],
        'isBestSeller': value['isBestSeller'],
        'sourceShippingPriceUsdMin': value['sourceShippingPriceUsdMin'],
        'sourceShippingPriceUsdMax': value['sourceShippingPriceUsdMax'],
        'sourceTotalOfferCountMin': value['sourceTotalOfferCountMin'],
        'sourceTotalOfferCountMax': value['sourceTotalOfferCountMax'],
        'sourcePrimeOfferCountMin': value['sourcePrimeOfferCountMin'],
        'sourcePrimeOfferCountMax': value['sourcePrimeOfferCountMax'],
        'deliveryPromiseDaysMin': value['deliveryPromiseDaysMin'],
        'deliveryPromiseDaysMax': value['deliveryPromiseDaysMax'],
        'returnable': value['returnable'],
        'freeReturns': value['freeReturns'],
        'amazonsChoice': value['amazonsChoice'],
        'primeExclusive': value['primeExclusive'],
        'voltageMin': value['voltageMin'],
        'voltageMax': value['voltageMax'],
        'bulbBase': value['bulbBase'],
        'powerSource': value['powerSource'],
        'sourceSalesRank': value['sourceSalesRank'],
        'targetSalesRank': value['targetSalesRank'],
        'targetCategoryBsrMin': value['targetCategoryBsrMin'],
        'targetCategoryBsrMax': value['targetCategoryBsrMax'],
        'targetSubcategoryBsrMin': value['targetSubcategoryBsrMin'],
        'targetSubcategoryBsrMax': value['targetSubcategoryBsrMax'],
        'totalOfferCountMin': value['totalOfferCountMin'],
        'totalOfferCountMax': value['totalOfferCountMax'],
        'targetHasPrimeOffer': value['targetHasPrimeOffer'],
        'targetHasBuybox': value['targetHasBuybox'],
        'targetHasAmazonSeller': value['targetHasAmazonSeller'],
        'targetHasFBASeller': value['targetHasFBASeller'],
        'sourceBuyboxSellerChinese': value['sourceBuyboxSellerChinese'],
        'sourceBrandAndSellerSame': value['sourceBrandAndSellerSame'],
        'targetChineseSeller': value['targetChineseSeller'],
        'targetBrandSeller': value['targetBrandSeller'],
        'sellingPriceMin': value['sellingPriceMin'],
        'sellingPriceMax': value['sellingPriceMax'],
        'totalCostUsdMin': value['totalCostUsdMin'],
        'totalCostUsdMax': value['totalCostUsdMax'],
        'profitUsdMin': value['profitUsdMin'],
        'profitUsdMax': value['profitUsdMax'],
        'minProfitUsdMin': value['minProfitUsdMin'],
        'minProfitUsdMax': value['minProfitUsdMax'],
        'priceDiffBuyboxMin': value['priceDiffBuyboxMin'],
        'priceDiffBuyboxMax': value['priceDiffBuyboxMax'],
        'priceDiffLowestMin': value['priceDiffLowestMin'],
        'priceDiffLowestMax': value['priceDiffLowestMax'],
        'isPriceBelowBuybox': value['isPriceBelowBuybox'],
        'matchMode': value['matchMode'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'createdBy': value['createdBy'],
    };
}
